// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"13":"64e1edb8","224":"e4700291","404":"2bb8d95f","660":"5639eda4","987":"c7db63f7"}[chunkId] + ".css";
};